import React from 'react'
import { AppBar, Toolbar, MenuItem, FormControl, Select } from '@material-ui/core'
import Button from '@mui/material/Button'
import AddIcon from '@material-ui/icons/AddCircle'
import CloseIcon from '@material-ui/icons/Close'

import useStyles from './styles'

const Header = ({ type, setType, addingCustomLocation, setAddingCustomLocation }) => {
    const classes = useStyles()

    return (
        <AppBar position="static">
            <Toolbar className={classes.toolbar}>
                <FormControl className={classes.formControl}>
                    <Select value={type} onChange={(e) => setType(e.target.value)}>
                        <MenuItem value="View All">View All</MenuItem>
                        <MenuItem value="Pharmacy">Pharmacy</MenuItem>
                        <MenuItem value="Substance Use Disorder Treatment">Substance Use Disorder Treatment</MenuItem>
                        <MenuItem value="Sharps Disposal">Sharps Disposal</MenuItem>
                        <MenuItem value="Health Clinic">Health Clinic</MenuItem>
                        <MenuItem value="HIV Services">HIV Services</MenuItem>
                        <MenuItem value="Syringe Exchange">Syringe Exchange</MenuItem>
                    </Select>
                </FormControl>
                {addingCustomLocation ? (
                    <CloseIcon style={{color: 'darkgray'}} onClick={() => setAddingCustomLocation(false)} />
                ) : (
                    <Button variant="outlined" startIcon={<AddIcon />} onClick={() => setAddingCustomLocation(true)}>
                        Add Location
                    </Button>
                )}
            </Toolbar>
        </AppBar>
    )
}

export default Header